export interface FactoryGalleryImage {
  image: string;
  labelKey: string;
}

export interface FactoryInfo {
  id: string;
  icon: string;
  nameKey: string;
  taglineKey: string;
  heroImage: string;
  gallery: FactoryGalleryImage[];
  historyKey: string;
  established: string | null;
  capacity: string | null;
  productKeys: string[];
  specialtyKeys: string[];
  automationKey: string;
  qcKey: string;
}

export const supplierNetworkHeroImage =
  'https://readdy.ai/api/search-image?query=Bright%20panoramic%20view%20of%20a%20modern%20cosmetic%20packaging%20manufacturing%20complex%20under%20clear%20blue%20sky%2C%20clean%20white%20and%20glass%20industrial%20buildings%20with%20contemporary%20architecture%2C%20rows%20of%20factory%20facilities%20with%20green%20landscaping%20and%20wide%20open%20plaza%2C%20bright%20airy%20daylight%2C%20cool%20fresh%20tones%2C%20professional%20architectural%20industrial%20photography%2C%20high%20detail%2C%20crisp%20composition&width=1800&height=1000&seq=supplier-hero-01&orientation=landscape&nocache=true';

export const supplierFactories: FactoryInfo[] = [
  {
    id: 'glass-bottles',
    icon: 'ri-flask-line',
    nameKey: 'factory.glass.name',
    taglineKey: 'factory.glass.tagline',
    heroImage:
      'https://readdy.ai/api/search-image?query=Modern%20glass%20bottle%20manufacturing%20factory%20exterior%2C%20large%20industrial%20building%20with%20glass%20furnace%20chimneys%20and%20clean%20facade%2C%20rows%20of%20clear%20glass%20cosmetic%20bottles%20being%20produced%2C%20bright%20daylight%2C%20professional%20industrial%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=1000&seq=supplier-glass-hero&orientation=landscape',
    gallery: [
      {
        image:
          'https://readdy.ai/api/search-image?query=Glass%20bottle%20production%20line%20inside%20a%20modern%20factory%2C%20molten%20glass%20glowing%20orange%20being%20shaped%20into%20cosmetic%20bottles%2C%20automated%20glass%20forming%20machines%2C%20conveyor%20belt%20with%20clear%20glass%20bottles%2C%20bright%20clean%20industrial%20interior%2C%20professional%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-glass-line&orientation=landscape',
        labelKey: 'gallery.productionLine',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Fully%20automated%20robotic%20arms%20handling%20clear%20glass%20cosmetic%20bottles%20on%20a%20high%20speed%20production%20line%2C%20modern%20fourth%20generation%20automation%20equipment%2C%20precision%20machinery%2C%20clean%20bright%20factory%20floor%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-glass-auto&orientation=landscape',
        labelKey: 'gallery.automation',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20area%20in%20a%20glass%20bottle%20factory%2C%20technicians%20in%20white%20coats%20inspecting%20clear%20cosmetic%20bottles%20under%20bright%20inspection%20lights%2C%20measuring%20instruments%2C%20clean%20sterile%20laboratory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-glass-qc&orientation=landscape',
        labelKey: 'gallery.qc',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Large%20glass%20bottle%20warehouse%20interior%20with%20neatly%20stacked%20crates%20of%20clear%20cosmetic%20bottles%20on%20pallet%20racks%2C%20bright%20organized%20storage%20facility%2C%20wide%20aisles%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-glass-warehouse&orientation=landscape',
        labelKey: 'gallery.warehouse',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Glass%20melting%20furnace%20with%20glowing%20molten%20glass%20inside%20a%20modern%20glassworks%2C%20raw%20glass%20cullet%20and%20silica%20sand%20materials%20nearby%2C%20warm%20orange%20glow%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-glass-furnace&orientation=landscape',
        labelKey: 'gallery.rawMaterial',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Close%20up%20of%20premium%20clear%20glass%20cosmetic%20bottles%20and%20cream%20jars%20arranged%20elegantly%20on%20a%20white%20display%20table%2C%20soft%20studio%20lighting%2C%20clean%20minimal%20background%2C%20product%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-glass-finished&orientation=landscape',
        labelKey: 'gallery.finished',
      },
    ],
    historyKey: 'factory.glass.history',
    established: 'factory.glass.established',
    capacity: 'factory.glass.capacity',
    productKeys: [
      'factory.glass.product1',
      'factory.glass.product2',
      'factory.glass.product3',
    ],
    specialtyKeys: [
      'factory.glass.spec1',
      'factory.glass.spec2',
      'factory.glass.spec3',
      'factory.glass.spec4',
    ],
    automationKey: 'factory.glass.automation',
    qcKey: 'factory.glass.qc',
  },
  {
    id: 'cosmetic-tubes',
    icon: 'ri-drop-line',
    nameKey: 'factory.tubes.name',
    taglineKey: 'factory.tubes.tagline',
    heroImage:
      'https://readdy.ai/api/search-image?query=Modern%20cosmetic%20tube%20manufacturing%20factory%20exterior%2C%20large%20clean%20industrial%20building%2C%20bright%20daylight%20with%20blue%20sky%2C%20professional%20industrial%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=1000&seq=supplier-tubes-hero&orientation=landscape',
    gallery: [
      {
        image:
          'https://readdy.ai/api/search-image?query=Cosmetic%20tube%20production%20line%2C%20colorful%20laminate%20and%20plastic%20squeeze%20tubes%20moving%20on%20conveyor%2C%20tube%20filling%20and%20sealing%20machines%2C%20bright%20clean%20factory%20interior%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-tubes-line&orientation=landscape',
        labelKey: 'gallery.productionLine',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Automated%20tube%20filling%20and%20capping%20machine%20with%20robotic%20precision%2C%20rows%20of%20cosmetic%20tubes%20on%20high%20speed%20automated%20line%2C%20modern%20automation%20equipment%2C%20clean%20bright%20factory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-tubes-auto&orientation=landscape',
        labelKey: 'gallery.automation',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Quality%20control%20lab%20for%20cosmetic%20tubes%2C%20technician%20inspecting%20tube%20seals%20and%20printing%20quality%20under%20magnifying%20lamp%2C%20clean%20laboratory%20with%20testing%20equipment%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-tubes-qc&orientation=landscape',
        labelKey: 'gallery.qc',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Multi%20color%20offset%20printing%20press%20printing%20colorful%20designs%20onto%20cosmetic%20laminate%20tubes%2C%20high%20speed%20printing%20machine%2C%20bright%20clean%20factory%20interior%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-tubes-printing&orientation=landscape',
        labelKey: 'gallery.printing',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Large%20rolls%20of%20laminate%20and%20plastic%20film%20material%20for%20tube%20production%20stacked%20in%20factory%20raw%20material%20storage%2C%20organized%20industrial%20warehouse%2C%20professional%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-tubes-material&orientation=landscape',
        labelKey: 'gallery.rawMaterial',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Colorful%20cosmetic%20squeeze%20tubes%20in%20various%20colors%20and%20sizes%20arranged%20in%20neat%20rows%20on%20display%2C%20clean%20bright%20product%20photography%2C%20soft%20studio%20lighting%2C%20high%20detail&width=800&height=600&seq=supplier-tubes-finished&orientation=landscape',
        labelKey: 'gallery.finished',
      },
    ],
    historyKey: 'factory.tubes.history',
    established: 'factory.tubes.established',
    capacity: 'factory.tubes.capacity',
    productKeys: [
      'factory.tubes.product1',
      'factory.tubes.product2',
      'factory.tubes.product3',
      'factory.tubes.product4',
    ],
    specialtyKeys: [
      'factory.tubes.spec1',
      'factory.tubes.spec2',
      'factory.tubes.spec3',
      'factory.tubes.spec4',
    ],
    automationKey: 'factory.tubes.automation',
    qcKey: 'factory.tubes.qc',
  },
  {
    id: 'plastic-bottles',
    icon: 'ri-archive-line',
    nameKey: 'factory.plastic.name',
    taglineKey: 'factory.plastic.tagline',
    heroImage:
      'https://readdy.ai/api/search-image?query=Plastic%20bottle%20manufacturing%20factory%20exterior%2C%20modern%20industrial%20building%2C%20PET%20bottle%20production%20facility%2C%20clean%20bright%20daylight%2C%20professional%20industrial%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=1000&seq=supplier-plastic-hero&orientation=landscape',
    gallery: [
      {
        image:
          'https://readdy.ai/api/search-image?query=PET%20plastic%20bottle%20blow%20molding%20production%20line%2C%20transparent%20plastic%20cosmetic%20bottles%20being%20formed%2C%20injection%20stretch%20blow%20molding%20machines%2C%20conveyor%20with%20bottles%2C%20bright%20clean%20factory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-plastic-line&orientation=landscape',
        labelKey: 'gallery.productionLine',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Automated%20plastic%20bottle%20production%20with%20robotic%20sorting%20and%20stacking%2C%20high%20speed%20blow%20molding%20line%2C%20modern%20automation%20equipment%2C%20clean%20bright%20factory%20floor%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-plastic-auto&orientation=landscape',
        labelKey: 'gallery.automation',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Plastic%20bottle%20quality%20inspection%20station%2C%20measuring%20bottle%20dimensions%20with%20precision%20instruments%2C%20clear%20plastic%20bottles%20under%20inspection%20light%2C%20clean%20laboratory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-plastic-qc&orientation=landscape',
        labelKey: 'gallery.qc',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Warehouse%20with%20stacks%20of%20transparent%20PET%20plastic%20bottles%20on%20wooden%20pallets%2C%20bright%20clean%20storage%20facility%2C%20organized%20logistics%20and%20shelving%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-plastic-warehouse&orientation=landscape',
        labelKey: 'gallery.warehouse',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Injection%20molding%20machines%20producing%20plastic%20bottle%20caps%20and%20components%2C%20modern%20injection%20molding%20workshop%2C%20precise%20machinery%2C%20clean%20bright%20factory%2C%20professional%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-plastic-molding&orientation=landscape',
        labelKey: 'gallery.molding',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Assortment%20of%20clear%20and%20colored%20plastic%20cosmetic%20bottles%20with%20pumps%20and%20spray%20nozzles%20on%20display%2C%20bright%20clean%20background%2C%20product%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-plastic-finished&orientation=landscape',
        labelKey: 'gallery.finished',
      },
    ],
    historyKey: 'factory.plastic.history',
    established: 'factory.plastic.established',
    capacity: 'factory.plastic.capacity',
    productKeys: [
      'factory.plastic.product1',
      'factory.plastic.product2',
      'factory.plastic.product3',
      'factory.plastic.product4',
    ],
    specialtyKeys: [
      'factory.plastic.spec1',
      'factory.plastic.spec2',
      'factory.plastic.spec3',
      'factory.plastic.spec4',
    ],
    automationKey: 'factory.plastic.automation',
    qcKey: 'factory.plastic.qc',
  },
  {
    id: 'cosmetic-packaging',
    icon: 'ri-box-3-line',
    nameKey: 'factory.packaging.name',
    taglineKey: 'factory.packaging.tagline',
    heroImage:
      'https://readdy.ai/api/search-image?query=Cosmetic%20packaging%20manufacturing%20facility%20exterior%2C%20large%20modern%20factory%20building%2C%20clean%20industrial%20architecture%2C%20bright%20daylight%2C%20professional%20industrial%20photography%2C%20clean%20composition%2C%20high%20detail&width=1600&height=1000&seq=supplier-pack-hero&orientation=landscape',
    gallery: [
      {
        image:
          'https://readdy.ai/api/search-image?query=Cosmetic%20packaging%20assembly%20and%20decoration%20line%2C%20various%20cosmetic%20containers%20bottles%20jars%20tubes%20caps%20being%20printed%20decorated%20and%20assembled%2C%20bright%20clean%20factory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-pack-line&orientation=landscape',
        labelKey: 'gallery.productionLine',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Automated%20cosmetic%20packaging%20assembly%20line%20with%20robotic%20arms%2C%20high%20speed%20multi%20color%20printing%20and%20labeling%20machines%2C%20modern%20automation%20equipment%2C%20clean%20bright%20factory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-pack-auto&orientation=landscape',
        labelKey: 'gallery.automation',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Cosmetic%20packaging%20quality%20control%20center%2C%20technicians%20inspecting%20finished%20packaging%20products%2C%20color%20matching%20and%20dimensional%20testing%20equipment%2C%20clean%20laboratory%2C%20professional%20industrial%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-pack-qc&orientation=landscape',
        labelKey: 'gallery.qc',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Assembly%20line%20where%20workers%20and%20automated%20machines%20assemble%20cosmetic%20packaging%20sets%20with%20caps%20pumps%20and%20bottles%2C%20clean%20bright%20factory%2C%20professional%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-pack-assembly&orientation=landscape',
        labelKey: 'gallery.assembly',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Cosmetic%20packaging%20decoration%20process%20with%20hot%20stamping%20and%20silk%20screen%20printing%20machines%20applying%20gold%20foil%20designs%2C%20clean%20factory%2C%20professional%20photography%2C%20high%20detail&width=800&height=600&seq=supplier-pack-decoration&orientation=landscape',
        labelKey: 'gallery.decoration',
      },
      {
        image:
          'https://readdy.ai/api/search-image?query=Complete%20cosmetic%20packaging%20sets%20with%20bottles%20jars%20and%20boxes%20displayed%20together%20in%20elegant%20presentation%2C%20bright%20studio%20lighting%2C%20clean%20minimal%20background%2C%20high%20detail&width=800&height=600&seq=supplier-pack-finished&orientation=landscape',
        labelKey: 'gallery.finished',
      },
    ],
    historyKey: 'factory.packaging.history',
    established: 'factory.packaging.established',
    capacity: 'factory.packaging.capacity',
    productKeys: [
      'factory.packaging.product1',
      'factory.packaging.product2',
      'factory.packaging.product3',
      'factory.packaging.product4',
    ],
    specialtyKeys: [
      'factory.packaging.spec1',
      'factory.packaging.spec2',
      'factory.packaging.spec3',
      'factory.packaging.spec4',
    ],
    automationKey: 'factory.packaging.automation',
    qcKey: 'factory.packaging.qc',
  },
];

export const qcChecklistKeys = [
  'qc.item1',
  'qc.item2',
  'qc.item3',
  'qc.item4',
  'qc.item5',
  'qc.item6',
];